import React, { useContext } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import FormattedPrice from 'src/components/BookingFlow/modules/ServiceSelect/FormattedPrice/FormattedPrice';
import { Section } from 'src/components/Section';
import { AppContext } from 'src/contexts/AppContext';
import { ReservationEndContext } from 'src/contexts/ReservationEndContext';
import { IPocket, PocketType } from 'src/entities/pocket';
import { useConditionalFetch } from 'src/hooks';
import { getActivePockets } from 'src/services/api/company';
import globalMessages from 'src/services/globalMessages';
import PaymentSelect from '../../PaymentSelect/PaymentSelect';

const messages = defineMessages({
    paymentSelect: {
        id: 'paymentSelect',
        defaultMessage: 'Fizetési mód'
    }
});

const PaymentSelectSection: React.FC = () => {

    const { company } = useContext(AppContext);
    const { displayedSubtotal, selectedPayment, hasOnlinePocket, actions: { setHasOnlinePocket, setSelectedPayment } } = useContext(ReservationEndContext);

    const checkOnlinePockets = (pocketList: IPocket[]) => {
        /* eslint-disable-next-line no-bitwise */
        setHasOnlinePocket(pocketList.some(pocket => (PocketType.Online === (pocket.Type & PocketType.Online))));
    }

    const isSelectNeeded = (company?.PaymentSettings.IsPaymentEnabled && displayedSubtotal && displayedSubtotal?.Price !== 0) as boolean;

    const [activePockets, isLoading] = useConditionalFetch(getActivePockets, checkOnlinePockets, isSelectNeeded, []);

    return (
        (hasOnlinePocket && company && isSelectNeeded && displayedSubtotal && !isLoading)
            ?
            <Section title={messages.paymentSelect}
                otherTitle={<div>
                    <FormattedMessage {...globalMessages.subtotal} />
                    <FormattedPrice value={displayedSubtotal.Price} currency={displayedSubtotal.Currency} />
                </div>}>
                <PaymentSelect
                    pockets={activePockets}
                    paymentType={company.PaymentSettings.PaymentType}
                    selected={selectedPayment}
                    onChange={setSelectedPayment}
                />
            </Section>
            :
            null
    )
}

export default PaymentSelectSection;